module.exports = __webpack_public_path__ + "img/ppst.38ce965a.png";